<template>
  <div id="container" class="cs_st">
    <!-- Main Visible -->
    <div class="section main_viswrap_cs">
      <div class="inner main_vis_cs">
        <h1 class="intro">{{ $t('views.help.customercenter.7924') }}</h1>
        <!-- Main Search Form -->
        <div class="search_wrap">
          <div class="search_area intro">
            <form @submit.prevent="searchFaq">
              <legend class="blind">검색</legend>
              <div class="search_box">
                <label for="search-book" class="lab hidden">{{
                  $t('views.help.customercenter.4777')
                }}</label>
                <input
                  id="search-book"
                  v-model="searchTerm"
                  type="text"
                  name="search"
                  :placeholder="$t('views.help.customercenter.4892')"
                />
                <button type="button" class="btn_search" @click="searchFaq">
                  <span class="svg_search"></span
                  ><span class="blind">검색</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="section fill">
      <div class="inner">
        <h2 class="intro">{{ $t('views.help.customercenter.4222') }}</h2>
        <ul class="list_menu">
          <li>
            <router-link :to="{ name: 'faq' }">{{
              $t('common.footer.7188')
            }}</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'events' }">{{
              $t('views.help.customercenter.7534')
            }}</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'notices' }">{{
              $t('views.help.customercenter.3131')
            }}</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'guide' }">{{
              $t('views.help.customercenter.7583')
            }}</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'app_guide' }">{{
              $t('views.help.customercenter.app')
            }}</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'sitemap' }">{{
              $t('views.help.customercenter.5669')
            }}</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'guide' }">{{
              $t('views.help.customercenter.7867')
            }}</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'terms' }">{{
              $t('views.help.customercenter.9197')
            }}</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'privacy' }">{{
              $t('views.help.customercenter.8930')
            }}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerCenter',
  data() {
    return {
      searchTerm: ''
    }
  },
  methods: {
    searchFaq() {
      const { searchTerm } = this
      this.$router.push({ name: 'faq', params: { searchTerm } })
    }
  }
}
</script>

<style lang="scss" scoped></style>
